export const VIEW_TOOLTIP_KEY = 'viewAngleTooltip'
export const HOTSPOT_TOOLTIP_KEY = 'hotspotTooltip'
export const EMAIL_LIST_KEY = 'emailList'
export const ORIGIN_KEY = 'origin'
export const CLIENT_NAME_KEY = 'clientName'

export const baseModelChanges = ["7", "4", "23", "25", "30"];

export const NoDimensionChangeAccessories = ["5", "16"]

export const SKIP_MODEL_CODE = ["ES"]

export const PDF_ORDER = {
  "IC": [
    [{ key: 25, inches: true }, { key: 7 }, { key: 5, bool: true }, { key: 3 }, { key: 16 }],
    [{ key: 20, main: true }, { key: 25, title: "Length", inches: true, isSpeedRailLength: true }, { key: 6, bool: true }],
    [{ key: 19, bool: true, main: true }, { key: 25, title: "Length", inches: true, isSodaGunLength: true }, { key: 7, title: "Depth", inches: true, hide: true }]],
  "FC": [{ name: "Length", value: '6"', custom: true }],
  "SG": [[{ key: 25, inches: true }, { key: 7 }]],
  "DB": [
    [{ key: 25, inches: true }, { key: 7 }, { key: 3 },],
    [{ key: 20, main: true }, { key: 6, bool: true }],
    [{ key: 9, main: true }],
  ],
  "CS3": [
    [{ key: 25, inches: true }, { key: 3 }, { key: 30, main: true }],
    [{ key: 20, main: true }, { key: 6, bool: true }],
    [{ key: 9, main: true }],
  ],
  "CS4": [
    [{ key: 25, inches: true }, { key: 3 },],
    [{ key: 20, main: true }, { key: 6, bool: true }],
    [{ key: 9, main: true }],
  ],
  "GR": [
    [{ key: 25, inches: true }, { key: 3 },],
    [{ key: 29, main: true }],
  ],
  "ES": [
    [{ key: 25, inches: true }],
  ],
  "OTHER": [
    [{ key: 25, inches: true }, { key: 3 },],
    [{ key: 9, main: true }],
    [{ key: 29, main: true }],
  ],
}

export const DEFAULT_VALUES = {
  23: "GR",
  3: "4",
  8: "000",
  13: "RE",
  14: "L",
  17: "WS",
  21: "SR",
  15: "Y",
  1: "00",
  11: "F",
  10: "ST",
  2: "1",
  27: "S",
  6: "Yes",
  24: "03",
  4: "EC"
}

export const DEFAULT_LENGTH = {
  fc: "6",
  hs: "12",
  bs: "12",
  db: "24",
  ld: "12",
  gr: "24",
}

export const DEFAULT_DEPTH = {
  fc: "S",
  hs: "F",
  bs: "F",
  db: "S",
  ld: "F",
  gr: "F",
  cs3: "S",
  cs4: "S",
  es: "F",
}

export const keys = {
  1: "accessories",
  2: "aerator",
  3: "backsplash height",
  4: "capacity",
  5: "cold plate",
  6: "cover",
  7: "depth",
  8: "door finish",
  9: "faucet",
  10: "faucet handles",
  11: "flex mount",
  12: "glass rinser",
  13: "handle",
  14: "hinge",
  15: "install",
  16: "lid",
  17: "shelving",
  18: "soap dispenser",
  19: "soda gun section",
  20: "speed rail",
  21: "splash guards",
  22: "style top",
  23: "type",
  24: "bottlewells",
  25: "length",
  26: "rail length",
  27: "rail alignment",
  28: "sheet metal variant",
  29: "door",
  30: "drain board",
  50: "back Cushion",
  51: "arm Style",
  52: "upholstery"
};

export const sortOrder = {
  '7': 1,
  '25': 2,
  '5': 3,
  '3': 4,
  '16': 5,
  '19': 6,
  '9': 7,
  '20': 8,
  '50': 9,
  '51': 10
};

export const valueKeys = {
  1: {
    11: "Cutting board",
    12: "Chemical storage pan",
    13: "Extra shelves",
    14: "Garnish tray",
    15: "Ice design plate",
    "01": "Flat inlays",
    "02": "Towel ring",
    "03": "Bottle cap catcher",
    "04": "Divider wire",
    "05": "Metal wet waste pan",
    "06": "Plastic wet waste pan",
    "07": "Standpipe",
    "08": "Crumb cup",
    "09": "Flat strainer",
  },
  2: {
    1: "0.5 GPM",
    2: "1.5 GPM",
    3: "2.0 GPM",
  },
  3: {
    "4": '4"',
    "6": '6"',
  },
  4: {
    EC: "Extra capacity",
  },
  5: {
    10: "10 circuit",
  },
  6: {
    C: "Cover with locks",
  },
  7: {
    S: "Standard",
    F: "Full",
  },
  8: {
    "027": "Matte black",
    "000": "Stainless",
  },
  9: {
    S6: 'Swing 6"',
    G3: 'Gooseneck 3-1/2"',
  },
  10: {
    ST: "Standard",
    "6W": '6" wrist',
    "4W": '4" wrist',
  },
  11: {
    FLX: "11",
  },
  12: {
    L: "Left",
    R: "Right",
  },
  13: {
    RE: "Recessed",
    SM: "Sheet metal",
    SP: "Spec",
  },
  14: {
    L: "Left",
    R: "Right",
  },
  15: {
    Y: "Factory",
    E: "Field",
  },
  16: {
    GL: "Glass",
    SM: "Sheet metal",
    GA: "Garnish",
    "sm4_left": "Sheet Metal - 4 Bottle wells",
    "sm4_right": "Sheet Metal - 4 Bottle wells",
    "sm8": "Sheet Metal - 8 Bottle wells",
    "sm8_left": "Sheet Metal - 8 Bottle wells",
    "sm8_right": "Sheet Metal - 8 Bottle wells",
    "sm3": "Sheet Metal - 3 Bottle wells",
    "sm3_left": "Sheet Metal - 3 Bottle wells",
    "sm3_right": "Sheet Metal - 3 Bottle wells",
    "sm6": "Sheet Metal - 6 Bottle wells",
    "sm6_left": "Sheet Metal - 6 Bottle wells",
    "sm6_right": "Sheet Metal - 6 Bottle wells",
  },
  17: {
    WS: "Wire shelf",
    SM: "Sheet metal",
    RO: "Roll outs",
    TS: "Tray slides",
  },
  18: {
    R: "Right",
    L: "Left",
  },
  19: {
    46: '4" Left/6" Right',
    64: '6" Left/4" Right',
    "4L": '4" Left',
    "4R": '4" Right',
    "4B": '4" Left/Right',
    "6L": '6" Left',
    "6R": '6" Right',
    "6B": '6" Left/Right',
  },
  20: {
    S: "Single rail",
    D: "Dual rail",
    SC: "Single rail with cover",
    DC: "Dual rail with cover",
  },
  21: {
    SR: "Splash Right",
    SL: "Splash Left",
    SB: "Splash Left/Right",
  },
  22: {
    FT: "Flat top",
    DB: "Drain board",
    BW: "Bottle well",
  },
  23: {
    GR: "Glass rack",
    W: "Wet",
  },
  27: {
    S: "Single",
    D: "Double",
  },
};

export const families = {
  "IC": "Ice Chest",
  "FC": "FILLER CHASE",
  "HS": "HAND SINK",
  "BS": "BLENDER STATION",
  "DB": "DRAIN BOARD",
  "LD": "LIQUOR DISPLAY",
  "GR": "Glass Rack",
  "SG": "Soda Gun",
  "CS3": "COMP SINK 3",
  "CS4": "COMP SINK 4",
}

export const IMAGES_KEYS_INDEX = {
  Perspective: 1,
  Plan: 2,
  Elevation: 3,
}


export const _offset = 0.00581
export const _bb_offset = 0.001

export const BB_OFFSET = 1 + _bb_offset
export const OFFSET = 1 - _offset

// Sofa Configurator
// export const PRIMARY_COLOR = "#8a97a7"
// export const HIGHLIGHT_COLOR = "#f7bbae"

// True Manufacturing
export const PRIMARY_COLOR = "#0e5682"
export const PRIMARY_COLOR_RGBA = {
  r: 0.054901960784313725,
  g: 0.33725490196078434,
  b: 0.5098039215686274,
  a: 1
}
export const HIGHLIGHT_COLOR = "#80ddff"


export const HIGHLIGHT_TILE = "#c5e14e"

export const DIMENSION_OBJECT_NAME = "IMAGINE_DIMENSION"
export const SHADOW_CATCHER_OBJECT_NAME = "SHADOW_CATCHER"

export const BUILD_PATH = "/build"
export const REPLACE_KEY = "REPLACE"

export const DEFAULT_TILE_SIZE = 0.5

export const DONE = "DONE"

export const OVERRIDES = {
  "16": {
    "S_sm4_left": "3 Left Hand",
    "S_sm4_right": "3 Right Hand",
    "S_sm8": "6",
    "S_sm8_left": "6 Left Hand",
    "S_sm8_right": "6 Right Hand"
  }
}

export const PROJECT_FILE_KEY = "__TRUE_PROJECT__"
export const CONFIGURATION_KEY = "CONFIGURATION"
export const PDF_CONFIGURATION_KEY = "PDF_CONFIGURATION"
export const DEPTH_CHANGEABLE_MODELS = (data) => Object?.keys(data || {})?.includes("25")

export const SPEC_SHEET = {
  main: "https://media-stag.imagine.io/media/public/true/pdfs/FULL+ICE+CHEST+-+SPEC+SHEET+PoC.pdf",
  acc: "https://media-stag.imagine.io/media/public/true/pdfs/SPEED+RAIL+-+SPEC+SHEET+PoC.pdf",
}

export const PRINT_VIEW = "PRINT"
export const FRONT_VIEW = "__FRONT_VIEW__"

export const DIMENSION_LINE_PREFIX = "__DIMENSION_LINE__"
export const STOP_MARKER_PREFIX = "__STOP_MARKER__"
export const SHADOW_PLANE_NAME = "_SHADOW_PLANE_"
export const BOUNDING_BOX_NAME = "_BOUNDING_BOX_"

export const PDF_CLASS_NAME_THUMBNAIL = "_TRUE_THUMBNAIL_"
export const PDF_CLASS_NAME_IMAGE = "_TRUE_IMAGE_"

export const OTHER_FILE_SUPPORTED_EXTENSIONS = [".jpg", ".png", ".pdf", ".jpeg"]

export const ENCODE_TOKEN = "rMQpankajv7easG04HbLCBw2O39vivekZU7N6Qu1QQ62ZkrnnWI"

export const BACKGROUND_COLOR = "#F6F6F6"
export const HDRI_PATH = "/HDRI/poolbeg_2k.hdr"
export const ROUGHNESS_MAP_PATH = "/TEXTURES/rougness.jpg"
export const EMPTY_MAP_BASE_PATH = "/TEXTURES/EMPTY/<texture_name>.png"


export const METAL_COLOR = {
  b: 1,
  g: 0.9999991655349731,
  r: 0.9999988675117493
}

export const KEYBOARD_KEYS = {
  DELETE: "Delete",
  ENTER: "Enter",
  NUMPAD_ENTER: "NumpadEnter",
  Z: "KeyZ",
  R: "KeyR",
}


export const SCREEN_CAPTURE_THRESHOLD = 3072
export const SCREEN_CAPTURE_COUNT = 3


export const JSON_TYPE = "application/json"
export const PDF_TYPE = "application/pdf"

export const VALID_PROJECT_FILES = [JSON_TYPE, PDF_TYPE]

export const MATERIAL_NAMES = {
  HIDE: "hide",
  EMPTY: "empty_",
  FRAME: "frame",
  FAUCET: "faucet",
  CHROME: "chrome",
}

export const MAP_OFFSET_REPEAT = {
  "30": {
    offset: { x: 0, y: -0.25 },
    repeat: { x: 1, y: 1.25 }
  },
  "12": {
    repeat: { x: 2, y: 1 }
  }
}

export const DONT_UPDATE_ICON = "TRUE_BUT_DONT_UPDATE_ICON"

// staging mail list
// CLIENT_MAP={
//   '1':'aakash@imagine.io',
//   '2':'vivek@imagine.io',
//   '3':'pankaj@imagine.io',
//   '4': 'gagan@imagine.io',
//   '5':'ajay@imagine.io',
//   '6':'shagun@imagine.io',
//   '8':'jyp@taglineinfotech.com',
//   '9':'pratik@imagine.io'
// } 

// production list
// CLIENT_MAP={
//   '1':'aakash@imagine.io',
//   '2':'vivek@imagine.io',
//   '3':'pankaj@imagine.io',
//   '4': 'gagan@imagine.io',
//   '5':'ajay@imagine.io',
//   '6':'shagun@imagine.io',
//   '7':'ProductConfigurations@truemfg.com',
//   '8':'jyp@taglineinfotech.com',
//   '9':'pratik@imagine.io',
//   '10':'surbhi@imagine.io',
//   '11':'henna@imagine.io',
//   '12':'adamw@trimlite.com',
// }

// export const CLIENT_EMAIL_ACCOUNTS = "9"
export const CLIENT_EMAIL_ACCOUNTS = "4,9,10,11"

export const INTERNAL_EMAIL_ACCOUNTS = "2,8,9,4"

export const AES_SECRET = "de88a8ac5de436ffe8b924fc3f0b3b25"

export const ACCESORIES_FOLDERS = {
  "20": "SPEED RAILS",
  "19": "SG",
  "9": "FAUCET",
  "3": "BACKSPLASH"
}

export const RESTRICTED_EMAIL_DOMAIN = [
  'imagine.io',
  'livefurnish.com',
  'taglineinfotech.com',
  'algoworks.com',
];
